import { useEffect, useState } from 'react';
import { Button, Grid, Header } from 'semantic-ui-react';
import PhotoWidgetCropper from './PhotoWidgetCropper';
import PhotoWidgetDropzone from './PhotoWidgetDropzone';
import '../MediaQuery/responsive-photo-crop.css';
import { userLanguage } from '../userLanguageSchema/userLanguage';
import { useStore } from '../../stores/store';
interface Props {
  loading: boolean;
  uploadPhoto: (file: Blob) => void;
}

export default function PhotoUploadWidget({ loading, uploadPhoto }: Props) {
  const [files, setFiles] = useState<any>([]);
  const [cropper, setCropper] = useState<Cropper>();
  const { commonStore } = useStore();
  function onCrop() {
    if (cropper) {
      cropper.getCroppedCanvas().toBlob((blob) => {
        if (blob) {
          uploadPhoto(blob);
        }
      });
    }
  }

  useEffect(() => {
    return () => {
      files.forEach((file: any) => URL.revokeObjectURL(file.preview));
    };
  }, [files]);

  return (
    <div className="Photouploadwidget">
      <Grid>
        <Grid.Column width={1} />
        <Grid.Column width={4}>
          <Header
            sub
            color="teal"
            content={
              (userLanguage[0].UploadProfilePhoto?.UPPSL01 as any)?.[
                `${commonStore.language.key}`
              ]
            } //"Upload Photo"
            style={{ marginBottom: '20px' }}
          />
          <PhotoWidgetDropzone setFiles={setFiles} photouploadalign={true} />
        </Grid.Column>
        <Grid.Column width={1} />
        <Grid.Column width={4}>
          <Header
            sub
            color="teal"
            content={
              (userLanguage[0].UploadProfilePhoto?.UPPSL02 as any)?.[
                `${commonStore.language.key}`
              ]
            } //"Resize image"
            style={{ marginBottom: '20px' }}
          />
          {files && files.length > 0 && (
            <PhotoWidgetCropper
              setCropper={setCropper}
              imagePreview={files[0].preview}
            />
          )}
        </Grid.Column>
        <Grid.Column width={1} />
        <Grid.Column width={3}>
          <Header
            sub
            color="teal"
            content={
              (userLanguage[0].UploadProfilePhoto?.UPPSL03 as any)?.[
                `${commonStore.language.key}`
              ]
            } //"Preview & Upload"
            style={{ marginBottom: '20px' }}
          />
          {files && files.length > 0 && (
            <>
              <div
                className="img-preview"
                style={{ minHeight: 200, overflow: 'hidden' }}
              />
              <Button.Group width={2}>
                <Button
                  loading={loading}
                  onClick={onCrop}
                  positive
                  icon="check"
                />
                <Button
                  disabled={loading}
                  onClick={() => setFiles([])}
                  icon="close"
                />
              </Button.Group>
            </>
          )}
        </Grid.Column>
      </Grid>
    </div>
  );
}
